import { useEffect, useState } from 'react'
import posthog from 'posthog-js'

const readFlags = () => {
  if (typeof posthog.featureFlags?.getFlagVariants === 'function') {
    return posthog.featureFlags.getFlagVariants() || {}
  }
  const flagKeys = posthog.feature_flags?.getFlags?.() || []
  const out = {}
  flagKeys.forEach(key => {
    out[key] = posthog.getFeatureFlag(key)
  })

  return out
}

/**
 * Subscribe to PostHog feature flag changes and return a stable
 * `{ [flagKey]: value }` map for use as a React state value.
 */
export const useFeatureFlags = () => {
  const [flags, setFlags] = useState(() => readFlags())

  useEffect(() => {
    const update = () => setFlags(readFlags())
    // `onFeatureFlags` returns an unsubscribe function.
    const unsubscribe = posthog.onFeatureFlags(update)
    // Cover cases where flags resolved before the subscription was attached.
    update()

    return () => {
      if (typeof unsubscribe === 'function') {
        unsubscribe()
      }
    }
  }, [])

  return flags
}

export default useFeatureFlags
